//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CRUDGenerico from '../../../../shared-components/generico/CRUDGenerico';
import ImportacaoLateral from './SellInLateral';
import ConteudoSellInConsolidado from './SellinTabelaConsolidado';
import ConteudoSellInDetalhado from './SellinTabelaDetalhado';

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'SellIn',
  extends: CRUDGenerico,
  data() {
    return {
      importacaoVisivel: false,
      tabelaDetalhadoAtiva: false,
      consolidado: null,
      sellInResources: this.$api.sellIn(this.$resource),
      tableHeaderConsolidado: [
        {
          name: this.$t('label.competencia'),
          tooltip: this.$t('label.competencia'),
          classes: [],
        },
        {
          name: this.$tc('label.cliente', 1),
          tooltip: this.$tc('label.cliente', 1),
          classes: [],
        },
        {
          name: this.$t('label.numero_nf'),
          tooltip: this.$t('label.numero_nota_fiscal'),
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.quantidade'),
          tooltip: this.$t('label.quantidade'),
          classes: ['md-hide-medium'],
        },
        {
          name: this.$tc('label.valor', 1),
          tooltip: this.$tc('label.valor', 1),
          classes: ['md-hide-medium'],
        },
      ],
      tableRowsConsolidado: [],
      paginasConsolidado: 0,
      carregandoConsolidado: false,

      tableHeaderDetalhado: [
        {
          name: this.$t('label.competencia'),
          tooltip: this.$t('label.competencia'),
          classes: [],
        },
        {
          name: this.$t('label.numero_nf'),
          tooltip: this.$t('label.numero_nota_fiscal'),
          classes: [],
        },
        {
          name: this.$tc('label.cliente', 1),
          tooltip: this.$tc('label.cliente', 1),
          classes: [],
        },
        {
          name: this.$t('label.seq_item'),
          tooltip: this.$t('label.seq_item'),
          classes: [],
        },
        {
          name: this.$tc('label.produto', 1),
          tooltip: this.$tc('label.produto', 1),
          classes: [],
        },
        {
          name: this.$t('label.un_medida'),
          tooltip: this.$t('label.unidade_medida'),
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.qtd'),
          tooltip: this.$t('label.quantidade_produto'),
          classes: ['md-hide-medium'],
        },
        {
          name: this.$t('label.valor_total'),
          tooltip: this.$t('label.valor_total'),
          classes: [],
        },
        {
          name: this.$t('label.valor_liquido'),
          tooltip: this.$t('label.valor_liquido'),
          classes: ['md-hide-medium'],
        },
      ],
      tableRowsDetalhado: [],
      filtro: null,
    };
  },
  computed: {
    ...generateComputed('Sellin', [
      'canImport',
      'canExport',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.startsWith('SELLIN')).length;
    },
  },
  components: {
    ConteudoSellInConsolidado,
    ConteudoSellInDetalhado,
    ImportacaoLateral,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    toggleImportacao() {
      this.importacaoVisivel = !this.importacaoVisivel;
    },
    organizarConsolidado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsConsolidado);
    },
    organizarDetalhado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsDetalhado);
    },
    requestExportacao(competencia, cb) {
      if (!this.canExport) {
        return;
      }
      const timeout = 1000 * 60 * 10; // 10 minutos
      const limit = 50000;
      const filtros = { ano_mes: competencia };

      this.exportarFiltros(filtros, cb, 'sellin_simples', limit, timeout);
    },
    cleanTableNoResultConsolidado(cb) {
      this.tableRowsConsolidado = [];
      if (cb) {
        cb();
      }
    },
    requestPopularConsolidadoFiltro(filtro) {
      if (filtro) {
        this.filtro = filtro.filter;
        this.requestPopularConsolidado();
      } else {
        this.filtro = null;
      }
    },
    requestPopularConsolidado(page = null, cb = null) {
      this.tabelaDetalhadoAtiva = false;
      this.consolidado = null;
      const pagination = { size: 10, page: 1 };
      if (page) {
        pagination.page = page;
      }
      if (this.filtro) {
        pagination.filtro = this.filtro;
      }

      this.carregandoConsolidado = true;
      this.sellInResources.listarConsolidado(pagination)
        .then((response) => {
          this.tableRowsConsolidado = response.data.resposta;

          const qtdeRegistros = response.data.quantidadeRegistrosPagina;
          this.paginasConsolidado = Math.ceil(qtdeRegistros / pagination.size);

          this.carregandoConsolidado = false;
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.$error(this, err);
          this.carregandoConsolidado = false;
        });
    },
    requestPopularDetalhado({ idcliente, competencia, numeronotafiscal }, filter = null) {
      this.sellInResources.listarDetalhado({
        nota: numeronotafiscal,
        competencia,
        idcliente,
        filter,
      })
        .then((response) => {
          const objetos = response.data;
          this.tableRowsDetalhado = [];

          if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
            this.tableRowsDetalhado.push(...objetos);
            if (!this.tabelaDetalhadoAtiva) {
              this.tabelaDetalhadoAtiva = true;
            }
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    detalharConsolidado(consolidado) {
      this.consolidado = consolidado;
      this.tableRowsDetalhado = [];
      this.tabelaDetalhadoAtiva = false;
      this.requestPopularDetalhado(consolidado);
    },
    detalhadoBusca(filter) {
      this.requestPopularDetalhado(this.consolidado, filter);
    },
    exibirTabConsolidado() {
      this.tabelaDetalhadoAtiva = false;
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
    this.requestPopularConsolidado();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-in/SellIn.vue?vue&type=script&lang=js&